import { put, takeLatest, call } from 'redux-saga/effects'
import { launchProgramsActions } from './launchProgramActions'
import { launchProgramsReducers } from './launchProgramsSlice'
import {
  getDraftProgramState,
  createDraftProgramState,
  deleteDraftProgramState,
} from 'features/Programs/Launch/launchProgramService'

function* setSelectedDateSaga(action: any) {
  yield put(launchProgramsReducers.setSelectedDate(action.payload))
}

function* setSelectedSegmentsSaga(action: any) {
  yield put(launchProgramsReducers.setSelectedSegments(action.payload))
}

function* setSelectedProgramsSaga(action: any) {
  yield put(launchProgramsReducers.setSelectedPrograms(action.payload))
}

function* setProgramNameSaga(action: any) {
  yield put(launchProgramsReducers.setProgramName(action.payload))
}

function* setCurrencySaga(action: any) {
  yield put(launchProgramsReducers.setCurrency(action.payload))
}

function* setIncompleteLaunchSaga(action: any) {
  yield put(launchProgramsReducers.setIncompleteLaunch(action.payload))
}

function* fetchDraftProgramStateSaga() {
  try {
    const response = yield call(getDraftProgramState)
    if (response.data.draftState) {
      yield put(launchProgramsReducers.setIncompleteLaunch(true))
      yield put(
        launchProgramsReducers.setDraftProgramState(response.data.draftState)
      )
    } else {
      yield put(launchProgramsReducers.setIncompleteLaunch(false))
    }
  } catch (error) {
    yield put(launchProgramsReducers.setIncompleteLaunch(false))
  }
}

function* saveDraftProgramStateSaga(action: any) {
  yield call(createDraftProgramState, action.payload)
}

function* deleteDraftProgramStateSaga() {
  yield call(deleteDraftProgramState)
  yield put(launchProgramsReducers.setIncompleteLaunch(false))
}

function* applyRehydrateStateSaga(action: any) {
  yield put(launchProgramsReducers.rehydrateState(action.payload))
}

function* clearStateForNewLaunchSaga() {
  yield put(launchProgramsReducers.setSateForNewLaunch())
}

export function* launchProgramsSaga() {
  yield takeLatest(
    launchProgramsActions.changeSelectedDate.type,
    setSelectedDateSaga
  )
  yield takeLatest(
    launchProgramsActions.changeSelectedSegments.type,
    setSelectedSegmentsSaga
  )
  yield takeLatest(
    launchProgramsActions.changeSelectedPrograms.type,
    setSelectedProgramsSaga
  )
  yield takeLatest(
    launchProgramsActions.changeProgramName.type,
    setProgramNameSaga
  )
  yield takeLatest(launchProgramsActions.changeCurrency.type, setCurrencySaga)
  yield takeLatest(
    launchProgramsActions.incompleteLaunch.type,
    setIncompleteLaunchSaga
  )
  yield takeLatest(
    launchProgramsActions.fetchDraftProgramState.type,
    fetchDraftProgramStateSaga
  )
  yield takeLatest(
    launchProgramsActions.saveDraftProgramState.type,
    saveDraftProgramStateSaga
  )
  yield takeLatest(
    launchProgramsActions.deleteDraftProgramState.type,
    deleteDraftProgramStateSaga
  )
  yield takeLatest(
    launchProgramsActions.applyRehydrateState.type,
    applyRehydrateStateSaga
  )
  yield takeLatest(
    launchProgramsActions.clearStateForNewLaunch.type,
    clearStateForNewLaunchSaga
  )
}

export default launchProgramsSaga
